import React, { useEffect } from 'react';

import Navbar from '../Navbar';
import MainSidebar from '../MainSidebar';
import { SkeletonBlock, SkeletonTableRows } from '../Skeleton';
import { applyAdminLayout } from '../../common/layout';

/*
 * Enquanto o código de uma tela da área logada é baixado (Suspense em
 * routes/ProtectedRoute): barra do topo e menu de verdade, e o conteúdo em
 * esqueleto (título, busca e uma lista).
 */
function PageSkeleton() {
  // Primeira tela depois de abrir o navegador: o <body> ainda não tem as
  // classes do AdminLTE (nem a do modo escuro)
  useEffect(() => {
    if (!document.body.classList.contains('sidebar-mini')) {
      applyAdminLayout();
    }
  }, []);

  return (
    <>
      <Navbar />
      <MainSidebar />

      <div className="content-wrapper" aria-busy="true">
        <div className="content-header">
          <div className="container-fluid">
            <SkeletonBlock className="fdr-skeleton-title" />
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="card card-primary card-outline">
              <div className="card-header">
                <SkeletonBlock width="80px" />
              </div>
              <div className="card-body">
                <div className="row">
                  {[0, 1, 2, 3].map(col => (
                    <div key={col} className="col-sm-3 mb-2">
                      <SkeletonBlock width="40%" className="mb-2" />
                      <SkeletonBlock className="fdr-skeleton-field" />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="card card-primary card-outline">
              <div className="card-body table-responsive p-0">
                <table className="table">
                  <tbody>
                    <SkeletonTableRows rows={8} columns={6} />
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default PageSkeleton;
